"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DragDialog',
  directives: {
    elDragDialog: _elDragDialog.default
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    isShowReadBtn: {
      type: Boolean,
      default: false
    },
    isShowFollow: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '50%'
    },
    isShowFull: {
      type: Boolean,
      default: true
    },
    beforeClose: Function,
    beforeCloseCheck: Function,
    appendToBody: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '100px'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    readFlagId: {
      type: String,
      default: ''
    },
    star: {
      type: Boolean,
      default: false
    },
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isFullScreen: this.fullscreen,
      isDisabled: false
    };
  },
  computed: {
    dVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(s) {
        this.$emit('update:visible', s);
      }
    }
    // isFullScreen: {
    //   get() {
    //     return this.fullscreen
    //   },
    //   set(s) {
    //     this.$emit('update:fullscreen', s)
    //   }
    // }
  },
  watch: {},
  mounted: function mounted() {
    // this.$refs.dragDialog.$el.childNodes[0].style.top = 500
  },
  methods: {
    handleDrag: function handleDrag() {
      this.$emit('handleDragMove'); // 移动回调
    },
    handleRead: function handleRead() {
      this.$confirm('确定标记为已读吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {}).catch(function () {
        return false;
      });
    },
    /* 全屏 */handleFull: function handleFull() {
      this.isFullScreen = !this.isFullScreen;
      this.$emit('update:fullscreen', this.isFullScreen);
      this.$emit('changeFull', this.isFullScreen);
      console.log('弹出', this, this.$refs);
      if (this.isFullScreen) {
        this.$refs.dragDialog.$el.childNodes[0].style.left = 0;
        this.$refs.dragDialog.$el.childNodes[0].style.top = 0;
      }
    },
    /* 关注 */handleStar: function handleStar() {
      this.$emit('update:star', !this.star);
      this.$emit('handleStar', !this.star);
    },
    /* 切换弹窗大小 */toggleFull: function toggleFull() {
      this.handleFull();
    },
    /* 关闭 */handleColse: function handleColse() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide());
      } else if (typeof this.beforeCloseCheck === 'function') {
        if (this.beforeCloseCheck()) {
          this.hide();
        }
      } else {
        this.hide();
      }
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.dVisible = false;
      }
    }
  }
};